<template>
    <div>
        <v-row>
            <v-col cols="8">
                <v-card>
                    <v-card-title>
                        لیست کامیون ها
                    </v-card-title>
                    <v-card-text>
                        <div class="container">
                            <div class="row ">
                                <v-data-table2
                                        height="400"
                                        fixed-header
                                        dense
                                    hide-default-footer
                                    disable-pagination
                                        class="margin-auto table-bordered"
                                        :headers="headers"
                                        :items="items"
                                    multi-sort
                                >
                                    <template v-slot:item.operation="{ item }">
<v-row>
    <v-col cols="6">
        <v-btn title="ویرایش" @click="edit_item(item)" outlined small color="warning">
            <v-icon small color="warning">mdi-pencil</v-icon>
        </v-btn>
    </v-col>
    <v-col cols="6">
        <v-btn title="حذف"  @click="delete_item_dialog(item)" outlined small color="error">
            <v-icon small color="error">mdi-delete</v-icon>
        </v-btn>
    </v-col>
</v-row>


                                    </template>
                                    <template v-slot:item.type="{ item }">
                                        <td v-if="item.type==1">تک</td>
                                        <td v-if="item.type==2">جفت</td>
                                    </template>
                                    <template v-slot:item.row_id="{ item }">
                                        <span >{{item._row_index+1}}</span>
                                    </template>
                                </v-data-table2>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="4">
                <v-card>
                    <v-card-title>
                        افزودن کامیون
                    </v-card-title>
                    <v-card-text>
                        <v-text-field
                                v-model="model.code"
                                dense
                                @keypress="isNumber"
                                id="truck_code"
                                v-on:keyup.enter="another_focus('truck_name')"
                                label="کد کامیون"/>
                        <v-text-field
                                id="truck_name"
                                v-model="model.name"
                                dense
                                v-on:keyup.enter="another_focus('truck_type')"
                                label="نام کامیون"/>
                        <v-select
                                label="تعداد محور"
                                id="truck_type"
                                v-model="model.type"
                                :items="[{label:'تک',value:1},{label:'جفت',value:2}]"
                                item-value="value"
                                item-text="label"

                        ></v-select>
                        <v-text-field
                            dense
                            id="truck_plate"
                                v-model="model.plate"
                                v-on:keyup.enter="another_focus('truck_driver')"
                                label="شماره پلاک"/>
                        <v-text-field
                                id="truck_driver"
                                dense
                                v-model="model.driver"
                                v-on:keyup.enter="another_focus('truck_summary')"
                                label="نام کامیوندار"/>
                        <v-text-field v-if="status_form==0"
                                      v-model="model.summary"
                                      id="truck_summary"
                                      dense
                                      v-on:keyup.enter="another_focus('add_truck')"
                                      label="توضیحات"/>
                        <v-text-field v-if="status_form!=0"
                                      v-model="model.summary"
                                      id="truck_summary"
                                      dense
                                      v-on:keyup.enter="another_focus('edit_truck')"
                                      label="توضیحات"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="status_form==0" color="success" id="add_truck" @click="insert_data()">ثبت</v-btn>
                        <v-btn v-if="status_form!=0" color="warning" id="edit_truck" @click="insert_data()">ویرایش
                        </v-btn>
                        <v-btn color="warning" @click="reset_form()">انصراف</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import Vue from 'vue'
    import { bus } from '../main'

    export default {
        name: 'OriginDownload',
        components: {},
        data () {
            return {
                confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
                items: [],
                status_form: 0,
                model: {
                    code: '',
                    name: '',
                    type: 1,
                    plate: '',
                    driver: '',
                    summary: '',
                },
                headers: [
                    {
                        text: 'ردیف',
                        value: 'row_id'
                    },
                    {
                        text: 'کد',
                        value: 'code'
                    },
                    {
                        text: 'نام',
                        value: 'name'
                    },
                    {
                        text: 'تعداد محور',
                        value: 'type'
                    },
                    {
                        text: 'کامیوندار',
                        value: 'driver'
                    },
                    {
                        text: 'شماره پلاک',
                        value: 'plate'
                    },
                    {
                        text: 'عملیات',
                        value: 'operation'
                    }
                ]
            }
        },
        mounted () {
            this.get_data()
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == 'true') {
                    this.delete_item()

                } else {
                    this.status_form = 0
                }
            })
        },
        methods: {
            reset_form () {
                this.model = {
                    code: '',
                    name: '',
                    type: 1,
                    plate: '',
                    driver: '',
                    summary: '',
                }
                this.status_form = 0
            },
            edit_item (item) {
                this.model = JSON.parse(JSON.stringify(item))
                this.model.type = parseInt(item.type);
                this.status_form = item.id
            },
            get_data () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                this.axios.post('/api/trucks/select', formData, {}).then(function (response) {

                    // items = content_cats.orders;
                    if (response.data.error == 0) {

                        self.items = response.data.data
                        self.items.sort((a, b) => a.code.localeCompare(b.code, undefined, {numeric: true, sensitivity: 'base'}));

                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', response.data.msg)

                    }

                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            insert_data () {
                var self = this
                const formData = new FormData()
                // formData.append('id', this.selected_province);
                var url = '/api/trucks/insert'
                if (this.status_form != 0) {
                    url = '/api/trucks/update'
                    formData.append('id', this.status_form)
                }
                formData.append('code', this.model.code)
                formData.append('name', this.model.name)
                formData.append('type', this.model.type)
                formData.append('plate', this.model.plate)
                formData.append('driver', this.model.driver)
                formData.append('summary', this.model.summary)

                this.axios.post(url, formData, {}).then(function (response) {
                    self.$root.modal_component.show_api_response_modals(response)

                    // items = content_cats.orders;
                    if (response.data.error == 0) {
                        self.reset_form()
                        self.get_data()
                    }
                }).catch(function (error) {
                    self.$root.modal_component.show_danger_modal('خطا در ثبت', 'لطفا تمامی موارد را چک کنید')

                    console.log(error)
                })

            },
            delete_item_dialog (item) {
                this.$root.modal_component.show_confirm_modal('هشدار', 'آیا مایل به حذف این ردیف هستید؟', ['تایید'], this.confirm_delete_name)
                this.status_form = item.id

            },
            delete_item () {
                const self = this
                const formData = new FormData()
                const url = '/api/trucks/delete'
                formData.append('id', this.status_form)

                this.axios.post(url, formData, {}).then((res) => {

                    if (res.data.error == 0) {
                        self.$root.modal_component.show_api_response_modals(res);
                    } else {
                        self.$root.modal_component.show_danger_modal('خطا', res.data.msg)
                    }
                    self.status_form = 0

                    self.get_data()

                })
                    .catch(function (error) {
                        console.log(error)
                    })
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
        }
    }
</script>
